<template>
  <div class="flex-1 relative">
    <!-- Map Component -->
    <GmapMap
      v-if="center && center.lat && center.lng && startPosition.lat && startPosition.lng && endPosition.lat && endPosition.lng"
      :center="center"
      :zoom="8"
      :options="{
        minZoom: 4,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
      }"
      class="w-full h-full"
      ref="map"
    >
      <GmapRectangle
        v-for="rect in rectangles"
        :key="rect.id"
        :bounds="rect.bounds"
        :editable="true"
        :draggable="true"
        @bounds_changed="(val) => $emit('bounds-changed', val, rect.id)"
      />

      <GmapMarker :position="startPosition" @click="$emit('update:center', startPosition)" />

      <GmapMarker
        v-for="(item, index) in bridgesList"
        :key="'bridge-' + index"
        :icon="require('@/assets/marker/bridge.png')"
        :position="{ lat: item.startLat, lng: item.startLng }"
        :label="{
          text: item.name,
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }"
      />

      <GmapMarker
        v-for="(item, index) in customPoints"
        :key="'customs-' + index"
        :icon="require('@/assets/marker/customspoints.png')"
        :position="{
          lat: Number(item.latitude),
          lng: Number(item.longitude),
        }"
        :label="{
          text: item.name + ' Sınır Kapısı',
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }"
      />

      <GmapPolyline
        v-bind:path.sync="polyLineList"
        v-bind:options="{
          strokeWidth: 20,
          strokeColor: '#C43A3A',
          editable: false,
          draggable: false
        }"
      />
      
      <GmapMarker
        v-for="(item, index) in filterWaypoints()"
        v-show="item.no"
        :key="index"
        :position="item"
        :label="{
          text: item.no + '. Teslim Noktası',
          color: '#374151',
          className: 'marker-label-modern',
          fontSize: '10px',
        }"
        :icon="{
          url: locationPinImages[(item.no - 1) % 5],
          scaledSize: { width: 24, height: 24 },
        }"
      />

      <GmapCircle
        v-if="circleCenter"
        :center="circleCenter"
        :radius="50"
        :editable="false"
        :draggable="isDragging"
        ref="circleRef"
      />

      <div v-for="(item, index) in tollsList" :key="'toll-' + index">
        <GmapMarker
          v-if="item.typeId === 1"
          :position="{ lat: item.startLat, lng: item.startLng }"
          :icon="require('@/assets/marker/hgs.png')"
          @click="$emit('update:center', { lat: item.startLat, lng: item.startLng })"
          :label="{
            text: `Giriş : ${item.name}`,
            color: '#374151',
            className: 'marker-label-modern',
            fontSize: '10px',
          }"
        />

        <GmapMarker
          v-if="item.typeId === 1"
          :position="{ lat: item.endLat, lng: item.endLng }"
          :icon="require('@/assets/marker/hgs.png')"
          @click="$emit('update:center', { lat: item.endLat, lng: item.endLng })"
          :label="{
            text: `Çıkış : ${item.name}`,
            color: '#374151',
            className: 'marker-label-modern',
            fontSize: '10px',
          }"
        />

        <GmapMarker
          v-if="item.typeName === 2"
          :position="{ lat: item.startLat, lng: item.startLng }"
          :icon="require('@/assets/marker/barrier.png')"
          @click="$emit('update:center', { lat: item.startLat, lng: item.startLng })"
          :label="{
            text: item.name,
            color: '#374151',
            className: 'marker-label-modern',
            fontSize: '10px',
          }"
        />
      </div>

      <GmapMarker
        :position="endPosition"
        :icon="require('@/assets/marker/flag.png')"
        @click="$emit('update:center', endPosition)"
      />
    </GmapMap>
  </div>
</template>

<script>
export default {
  name: 'RouteMapContainer',
  props: {
    startPosition: {
      type: Object,
      required: true
    },
    endPosition: {
      type: Object,
      required: true
    },
    center: {
      type: Object,
      default: () => ({ lat: 39.9334, lng: 32.8597 })
    },
    waypoints: {
      type: Array,
      default: () => []
    },
    polyLineList: {
      type: Array,
      default: () => []
    },
    tollsList: {
      type: Array,
      default: () => []
    },
    bridgesList: {
      type: Array,
      default: () => []
    },
    customPoints: {
      type: Array,
      default: () => []
    },
    rectangles: {
      type: Array,
      default: () => []
    },
    circleCenter: {
      type: Object,
      default: null
    },
    isDragging: {
      type: Boolean,
      default: false
    },
    locationPinImages: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    'update:center',
    'mouse-move',
    'enable-dragging',
    'finalize-position',
    'bounds-changed'
  ],
  methods: {
    filterWaypoints() {
      return this.waypoints.filter((r) => r.type != "route");
    },
    handleMouseMove(event) {
      this.$emit('mouse-move', event);
    },
    enableDragging(event) {
      this.$emit('enable-dragging', event);
    },
    finalizePosition(event) {
      this.$emit('finalize-position', event);
    },
    onBoundsChanged(val) {
      this.$emit('bounds-changed', val);
    }
  }
}
</script>

<style scoped>
/* Modern Marker Label Styles */
:global(.marker-label-modern) {
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 500;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
}
</style>